import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import SelectPaymentOption from './SelectPaymentOption';
import {useDebtPaymentFailed} from '../hooks/useDebtPaymentFailed';
import {selectSelectedBanData, selectPaymentAmount, selectPaymentAction} from '../DebtAndUpdatePaymentBlockSlice';
import {dwhCreditCardPageReport, DwhActionType, DWHMessageText, DWHStatus} from '../reports/dwhReports';
import {paymentAction, stepEnum} from '../Constants/debtPaymentEnum';

const DebtPaymentError = () => {
  const {actions} = useDebtPaymentFailed();
  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const paymentActionType = useSelector(selectPaymentAction);
  const loginData = useSelector((state) => state.authentication.loginData);
  const bansForUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);
  const currentStep = useSelector((state) => state.debtAndUpdatePayment.currentStep);
  const yDaysCount = useSelector((state) => state.debtAndUpdatePayment.paymentStatusDisplayDaysY);
  const yDaysCountEnergy = useSelector((state) => state.debtAndUpdatePayment.energyPaymentStatusDisplayDaysY);
  useEffect(() => {
    if (currentStep == stepEnum.PAYMENTFAILED || currentStep == stepEnum.CREDITPAYMENTERROR) {
      dwhCreditCardPageReport({
        banData: selectedBanData,
        loginData,
        paymentAmount,
        paymentActionType,
        bansForUpdate,
        actionType:
          paymentActionType === paymentAction.PAYMENT_AND_UPDATE
            ? DwhActionType.PaymentAndUpdateTransaction
            : DwhActionType.PaymentOnlyTransaction,
        messageText: DWHMessageText.GeneralError,
        status: DWHStatus.Error,
        yDaysCount,
        yDaysCountEnergy,
      });
      actions.resetCGStore();
    }
  }, []);
  return (
    <div className='debtpayment-step payment-error-step'>
      <SelectPaymentOption />
    </div>
  );
};

export default DebtPaymentError;
